// extracted by mini-css-extract-plugin
module.exports = {"main-component":"replanSprint_main-component__3afUc"};